
// START - AI Product Bundle Builder price formatting (Please do not remove this)

(function () {
  const priceFormatter = new Intl.NumberFormat("es-CO", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  });

  // Keep the existing BYB formatting rules.
  const BYB_SELECTOR = ".child-prod-price, .page-offer-text";

  const MAM_SELECTOR = [
    ".essenify-mam-product-price",
    ".essenify-mam-original-price",
    ".essenify-mam-price-val",
    ".essenify-mam-rule-badge"
  ].join(", ");

  function formatPriceText(text) {
    return text.replace(
      /(\$\s*)?(\d[\d,]*(?:\.\d+)?)/g,
      function (match, symbol, number) {
        const value = Number(number.replace(/,/g, ""));

        if (!Number.isFinite(value) || value < 1000) {
          return match;
        }

        return (symbol || "") + priceFormatter.format(value);
      }
    );
  }

  // BYB formatter: retained independently.
  function formatBYBElement(element) {
    if (!element || !element.isConnected) return;

    const originalText = element.textContent;
    if (!originalText || !/\d{4,}/.test(originalText)) return;

    const formattedText = formatPriceText(originalText);

    if (formattedText !== originalText) {
      element.textContent = formattedText;
    }
  }

  function initializeBYBFormatting() {
    document.querySelectorAll(BYB_SELECTOR).forEach(formatBYBElement);

    const observer = new MutationObserver(function (mutations) {
      const elements = new Set();

      mutations.forEach(function (mutation) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return;

            if (node.matches(BYB_SELECTOR)) elements.add(node);

            node.querySelectorAll(BYB_SELECTOR).forEach(function (element) {
              elements.add(element);
            });
          });
        }

        const target = mutation.target.nodeType === Node.ELEMENT_NODE
          ? mutation.target
          : mutation.target.parentElement;

        const element = target && target.closest(BYB_SELECTOR);
        if (element) elements.add(element);
      });

      elements.forEach(formatBYBElement);
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // MAM formatter: normalizes comma-separated prices independently.
  function formatMAMElement(element) {
    if (!element || !element.isConnected) return;

    const originalText = element.textContent;
    if (!originalText || !/\d/.test(originalText)) return;

    // Match currency and numeric value as a single price.
    const formattedText = originalText.replace(
      /(\$\s*)?(\d[\d,]*(?:\.\d+)?)/g,
      function (match, symbol, number) {
        const value = Number(number.replace(/,/g, ""));

        if (!Number.isFinite(value) || value < 1000) {
          return match;
        }

        return (symbol || "") + priceFormatter.format(value);
      }
    );

    if (formattedText !== originalText) {
      element.textContent = formattedText;
    }
  }

  function initializeMAMFormatting() {
    function formatAllMAMPrices() {
      document.querySelectorAll(MAM_SELECTOR).forEach(formatMAMElement);
    }

    formatAllMAMPrices();

    const observer = new MutationObserver(function () {
      formatAllMAMPrices();
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function initialize() {
    initializeBYBFormatting();
    initializeMAMFormatting();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();

// END - AI Product Bundle Builder price formatting (Please do not remove this)
